import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { initializeSocket } from '../services/socketService';

/**
 * Gerçek zamanlı bildirim sistemi için WebSocket bağlantısını başlatan bileşen
 * App.js içinde NotificationsProvider'ın altında kullanılmalı
 */
const RealTimeProvider = ({ children }) => {
  const { token, isAuthenticated } = useAuth();
  
  useEffect(() => {
    // Kullanıcı oturum açtıysa socket bağlantısını başlat
    if (isAuthenticated && token) {
      // console.log("token", token);
      initializeSocket(token);
    }
  }, [isAuthenticated, token]);
  

  return children;
};

export default RealTimeProvider;